export { Action } from '@jarvis/jweb-core';
export const ANDROID = 'android';
export const MAC = 'mac';
export const IOS = 'ios';
export const WINDOWS = 'windows';
export const WEB = 'web';

export const DSP = 'dsp';
export const REDIRECT = 'url';
export const CREATEACCOUNT = 'createAccount';
export const SIGNIN = 'signin';
export const SHOWALL = 'showAll';
export const CLOSEJWEB = 'closeJweb';
export const GOHOME = 'goHome';
export const LAUNCHTILE = 'launchTile';
export const INTERSTITIAL = 'interstitial';
export const DEEPLINK = 'deepLink';

export const SHOWHPPLUSCONVERSION = 'showHpPlusConversion';
export const SHOWHPXBANNER = 'showHpxBanner';
export const LAUNCHHPX = 'launchHpx';
export const CALLTYPE = 'P2';
export const CALLVALUE = 'YETI';

export const NativeTriggers = [DSP, LAUNCHTILE, SHOWHPPLUSCONVERSION, CREATEACCOUNT, SIGNIN];

export const EVENT_SCHEMA_VERSION = '1.4.0';
export const SIMPLE_UI_SCHEMA_VERSION = '1.5.0';
export const SIMPLE_UI_GUN =
  'com.hp.cdm.domain.telemetry.type.eventDetail.category.simpleUi.version.1';
export const SIMPLE_UI_CATEGORY = 'simpleUi';
export const APP_INSTANCE_KEY = 'appInstanceId';
export const LOCALE_KEY = 'locale';
export const PUBLISHER_ID = 'com.hp.jarvis.cec.datacollection.publisher';
export const AUTH_PUBLISHER_ID = 'com.hp.jarvis.auth.event.publisher'
export const AUTH_CHANGE_EVENT = 'com.hp.jarvis.auth.event.login.change'
export const PRINTER_SELECTED_EVENT = 'PrinterSelected'
export const PRINTER_PUBLISHER_ID = 'com.hp.hp-smart'
export const PRINTER_INFO_KEYWORDS = ['printerUUID', 'printerModel', 'printerSessionID'];
